require("core-js/modules/es6.object.define-property");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("promesa.protocols.js");
goog.provide('promesa.protocols');
/**
 * A promise abstraction.
 * @interface
 */

promesa.protocols.IPromise = function () {};

var promesa$protocols$IPromise$_bind$dyn_22740 = function () {
  var G__22741 = null;

  var G__22741__2 = function G__22741__2(_, f) {
    var x__4428__auto__ = _ == null ? null : _;

    var m__4429__auto__ = promesa.protocols._bind[goog.typeOf(x__4428__auto__)];

    if (!(m__4429__auto__ == null)) {
      return m__4429__auto__.cljs$core$IFn$_invoke$arity$2 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$2(_, f) : m__4429__auto__.call(null, _, f);
    } else {
      var m__4426__auto__ = promesa.protocols._bind["_"];

      if (!(m__4426__auto__ == null)) {
        return m__4426__auto__.cljs$core$IFn$_invoke$arity$2 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$2(_, f) : m__4426__auto__.call(null, _, f);
      } else {
        throw cljs.core.missing_protocol("IPromise.-bind", _);
      }
    }
  };

  var G__22741__3 = function G__22741__3(_, f, executor) {
    var x__4428__auto__ = _ == null ? null : _;

    var m__4429__auto__ = promesa.protocols._bind[goog.typeOf(x__4428__auto__)];

    if (!(m__4429__auto__ == null)) {
      return m__4429__auto__.cljs$core$IFn$_invoke$arity$3 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$3(_, f, executor) : m__4429__auto__.call(null, _, f, executor);
    } else {
      var m__4426__auto__ = promesa.protocols._bind["_"];

      if (!(m__4426__auto__ == null)) {
        return m__4426__auto__.cljs$core$IFn$_invoke$arity$3 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$3(_, f, executor) : m__4426__auto__.call(null, _, f, executor);
      } else {
        throw cljs.core.missing_protocol("IPromise.-bind", _);
      }
    }
  };

  G__22741 = function G__22741(_, f, executor) {
    switch (arguments.length) {
      case 2:
        return G__22741__2.call(this, _, f);

      case 3:
        return G__22741__3.call(this, _, f, executor);
    }

    throw new Error('Invalid arity: ' + arguments.length);
  };

  G__22741.cljs$core$IFn$_invoke$arity$2 = G__22741__2;
  G__22741.cljs$core$IFn$_invoke$arity$3 = G__22741__3;
  return G__22741;
}();
/**
 * Apply function to a computation and flatten.
 */


promesa.protocols._bind = function promesa$protocols$_bind(var_args) {
  var G__22692 = arguments.length;

  switch (G__22692) {
    case 2:
      return promesa.protocols._bind.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return promesa.protocols._bind.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

promesa.protocols._bind.cljs$core$IFn$_invoke$arity$2 = function (_, f) {
  if (!(_ == null) && !(_.promesa$protocols$IPromise$_bind$arity$2 == null)) {
    return _.promesa$protocols$IPromise$_bind$arity$2(_, f);
  } else {
    return promesa$protocols$IPromise$_bind$dyn_22740(_, f);
  }
};

promesa.protocols._bind.cljs$core$IFn$_invoke$arity$3 = function (_, f, executor) {
  if (!(_ == null) && !(_.promesa$protocols$IPromise$_bind$arity$3 == null)) {
    return _.promesa$protocols$IPromise$_bind$arity$3(_, f, executor);
  } else {
    return promesa$protocols$IPromise$_bind$dyn_22740(_, f, executor);
  }
};

promesa.protocols._bind.cljs$lang$maxFixedArity = 3;

var promesa$protocols$IPromise$_map$dyn_22743 = function () {
  var G__22744 = null;

  var G__22744__2 = function G__22744__2(_, f) {
    var x__4428__auto__ = _ == null ? null : _;

    var m__4429__auto__ = promesa.protocols._map[goog.typeOf(x__4428__auto__)];

    if (!(m__4429__auto__ == null)) {
      return m__4429__auto__.cljs$core$IFn$_invoke$arity$2 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$2(_, f) : m__4429__auto__.call(null, _, f);
    } else {
      var m__4426__auto__ = promesa.protocols._map["_"];

      if (!(m__4426__auto__ == null)) {
        return m__4426__auto__.cljs$core$IFn$_invoke$arity$2 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$2(_, f) : m__4426__auto__.call(null, _, f);
      } else {
        throw cljs.core.missing_protocol("IPromise.-map", _);
      }
    }
  };

  var G__22744__3 = function G__22744__3(_, f, executor) {
    var x__4428__auto__ = _ == null ? null : _;

    var m__4429__auto__ = promesa.protocols._map[goog.typeOf(x__4428__auto__)];

    if (!(m__4429__auto__ == null)) {
      return m__4429__auto__.cljs$core$IFn$_invoke$arity$3 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$3(_, f, executor) : m__4429__auto__.call(null, _, f, executor);
    } else {
      var m__4426__auto__ = promesa.protocols._map["_"];

      if (!(m__4426__auto__ == null)) {
        return m__4426__auto__.cljs$core$IFn$_invoke$arity$3 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$3(_, f, executor) : m__4426__auto__.call(null, _, f, executor);
      } else {
        throw cljs.core.missing_protocol("IPromise.-map", _);
      }
    }
  };

  G__22744 = function G__22744(_, f, executor) {
    switch (arguments.length) {
      case 2:
        return G__22744__2.call(this, _, f);

      case 3:
        return G__22744__3.call(this, _, f, executor);
    }

    throw new Error('Invalid arity: ' + arguments.length);
  };

  G__22744.cljs$core$IFn$_invoke$arity$2 = G__22744__2;
  G__22744.cljs$core$IFn$_invoke$arity$3 = G__22744__3;
  return G__22744;
}();
/**
 * Apply function to a computation
 */


promesa.protocols._map = function promesa$protocols$_map(var_args) {
  var G__22696 = arguments.length;

  switch (G__22696) {
    case 2:
      return promesa.protocols._map.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return promesa.protocols._map.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

promesa.protocols._map.cljs$core$IFn$_invoke$arity$2 = function (_, f) {
  if (!(_ == null) && !(_.promesa$protocols$IPromise$_map$arity$2 == null)) {
    return _.promesa$protocols$IPromise$_map$arity$2(_, f);
  } else {
    return promesa$protocols$IPromise$_map$dyn_22743(_, f);
  }
};

promesa.protocols._map.cljs$core$IFn$_invoke$arity$3 = function (_, f, executor) {
  if (!(_ == null) && !(_.promesa$protocols$IPromise$_map$arity$3 == null)) {
    return _.promesa$protocols$IPromise$_map$arity$3(_, f, executor);
  } else {
    return promesa$protocols$IPromise$_map$dyn_22743(_, f, executor);
  }
};

promesa.protocols._map.cljs$lang$maxFixedArity = 3;

var promesa$protocols$IPromise$_then$dyn_22747 = function () {
  var G__22748 = null;

  var G__22748__2 = function G__22748__2(_, f) {
    var x__4428__auto__ = _ == null ? null : _;

    var m__4429__auto__ = promesa.protocols._then[goog.typeOf(x__4428__auto__)];

    if (!(m__4429__auto__ == null)) {
      return m__4429__auto__.cljs$core$IFn$_invoke$arity$2 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$2(_, f) : m__4429__auto__.call(null, _, f);
    } else {
      var m__4426__auto__ = promesa.protocols._then["_"];

      if (!(m__4426__auto__ == null)) {
        return m__4426__auto__.cljs$core$IFn$_invoke$arity$2 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$2(_, f) : m__4426__auto__.call(null, _, f);
      } else {
        throw cljs.core.missing_protocol("IPromise.-then", _);
      }
    }
  };

  var G__22748__3 = function G__22748__3(_, f, executor) {
    var x__4428__auto__ = _ == null ? null : _;

    var m__4429__auto__ = promesa.protocols._then[goog.typeOf(x__4428__auto__)];

    if (!(m__4429__auto__ == null)) {
      return m__4429__auto__.cljs$core$IFn$_invoke$arity$3 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$3(_, f, executor) : m__4429__auto__.call(null, _, f, executor);
    } else {
      var m__4426__auto__ = promesa.protocols._then["_"];

      if (!(m__4426__auto__ == null)) {
        return m__4426__auto__.cljs$core$IFn$_invoke$arity$3 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$3(_, f, executor) : m__4426__auto__.call(null, _, f, executor);
      } else {
        throw cljs.core.missing_protocol("IPromise.-then", _);
      }
    }
  };

  G__22748 = function G__22748(_, f, executor) {
    switch (arguments.length) {
      case 2:
        return G__22748__2.call(this, _, f);

      case 3:
        return G__22748__3.call(this, _, f, executor);
    }

    throw new Error('Invalid arity: ' + arguments.length);
  };

  G__22748.cljs$core$IFn$_invoke$arity$2 = G__22748__2;
  G__22748.cljs$core$IFn$_invoke$arity$3 = G__22748__3;
  return G__22748;
}();
/**
 * Apply function to a computation and flatten if promise found.
 */


promesa.protocols._then = function promesa$protocols$_then(var_args) {
  var G__22700 = arguments.length;

  switch (G__22700) {
    case 2:
      return promesa.protocols._then.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return promesa.protocols._then.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

promesa.protocols._then.cljs$core$IFn$_invoke$arity$2 = function (_, f) {
  if (!(_ == null) && !(_.promesa$protocols$IPromise$_then$arity$2 == null)) {
    return _.promesa$protocols$IPromise$_then$arity$2(_, f);
  } else {
    return promesa$protocols$IPromise$_then$dyn_22747(_, f);
  }
};

promesa.protocols._then.cljs$core$IFn$_invoke$arity$3 = function (_, f, executor) {
  if (!(_ == null) && !(_.promesa$protocols$IPromise$_then$arity$3 == null)) {
    return _.promesa$protocols$IPromise$_then$arity$3(_, f, executor);
  } else {
    return promesa$protocols$IPromise$_then$dyn_22747(_, f, executor);
  }
};

promesa.protocols._then.cljs$lang$maxFixedArity = 3;

var promesa$protocols$IPromise$_mapErr$dyn_22756 = function () {
  var G__22757 = null;

  var G__22757__2 = function G__22757__2(_, f) {
    var x__4428__auto__ = _ == null ? null : _;

    var m__4429__auto__ = promesa.protocols._mapErr[goog.typeOf(x__4428__auto__)];

    if (!(m__4429__auto__ == null)) {
      return m__4429__auto__.cljs$core$IFn$_invoke$arity$2 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$2(_, f) : m__4429__auto__.call(null, _, f);
    } else {
      var m__4426__auto__ = promesa.protocols._mapErr["_"];

      if (!(m__4426__auto__ == null)) {
        return m__4426__auto__.cljs$core$IFn$_invoke$arity$2 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$2(_, f) : m__4426__auto__.call(null, _, f);
      } else {
        throw cljs.core.missing_protocol("IPromise.-mapErr", _);
      }
    }
  };

  var G__22757__3 = function G__22757__3(_, f, executor) {
    var x__4428__auto__ = _ == null ? null : _;

    var m__4429__auto__ = promesa.protocols._mapErr[goog.typeOf(x__4428__auto__)];

    if (!(m__4429__auto__ == null)) {
      return m__4429__auto__.cljs$core$IFn$_invoke$arity$3 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$3(_, f, executor) : m__4429__auto__.call(null, _, f, executor);
    } else {
      var m__4426__auto__ = promesa.protocols._mapErr["_"];

      if (!(m__4426__auto__ == null)) {
        return m__4426__auto__.cljs$core$IFn$_invoke$arity$3 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$3(_, f, executor) : m__4426__auto__.call(null, _, f, executor);
      } else {
        throw cljs.core.missing_protocol("IPromise.-mapErr", _);
      }
    }
  };

  G__22757 = function G__22757(_, f, executor) {
    switch (arguments.length) {
      case 2:
        return G__22757__2.call(this, _, f);

      case 3:
        return G__22757__3.call(this, _, f, executor);
    }

    throw new Error('Invalid arity: ' + arguments.length);
  };

  G__22757.cljs$core$IFn$_invoke$arity$2 = G__22757__2;
  G__22757.cljs$core$IFn$_invoke$arity$3 = G__22757__3;
  return G__22757;
}();
/**
 * Apply function to a failed computation.
 */


promesa.protocols._mapErr = function promesa$protocols$_mapErr(var_args) {
  var G__22703 = arguments.length;

  switch (G__22703) {
    case 2:
      return promesa.protocols._mapErr.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return promesa.protocols._mapErr.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

promesa.protocols._mapErr.cljs$core$IFn$_invoke$arity$2 = function (_, f) {
  if (!(_ == null) && !(_.promesa$protocols$IPromise$_mapErr$arity$2 == null)) {
    return _.promesa$protocols$IPromise$_mapErr$arity$2(_, f);
  } else {
    return promesa$protocols$IPromise$_mapErr$dyn_22756(_, f);
  }
};

promesa.protocols._mapErr.cljs$core$IFn$_invoke$arity$3 = function (_, f, executor) {
  if (!(_ == null) && !(_.promesa$protocols$IPromise$_mapErr$arity$3 == null)) {
    return _.promesa$protocols$IPromise$_mapErr$arity$3(_, f, executor);
  } else {
    return promesa$protocols$IPromise$_mapErr$dyn_22756(_, f, executor);
  }
};

promesa.protocols._mapErr.cljs$lang$maxFixedArity = 3;

var promesa$protocols$IPromise$_thenErr$dyn_22759 = function () {
  var G__22760 = null;

  var G__22760__2 = function G__22760__2(_, f) {
    var x__4428__auto__ = _ == null ? null : _;

    var m__4429__auto__ = promesa.protocols._thenErr[goog.typeOf(x__4428__auto__)];

    if (!(m__4429__auto__ == null)) {
      return m__4429__auto__.cljs$core$IFn$_invoke$arity$2 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$2(_, f) : m__4429__auto__.call(null, _, f);
    } else {
      var m__4426__auto__ = promesa.protocols._thenErr["_"];

      if (!(m__4426__auto__ == null)) {
        return m__4426__auto__.cljs$core$IFn$_invoke$arity$2 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$2(_, f) : m__4426__auto__.call(null, _, f);
      } else {
        throw cljs.core.missing_protocol("IPromise.-thenErr", _);
      }
    }
  };

  var G__22760__3 = function G__22760__3(_, f, executor) {
    var x__4428__auto__ = _ == null ? null : _;

    var m__4429__auto__ = promesa.protocols._thenErr[goog.typeOf(x__4428__auto__)];

    if (!(m__4429__auto__ == null)) {
      return m__4429__auto__.cljs$core$IFn$_invoke$arity$3 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$3(_, f, executor) : m__4429__auto__.call(null, _, f, executor);
    } else {
      var m__4426__auto__ = promesa.protocols._thenErr["_"];

      if (!(m__4426__auto__ == null)) {
        return m__4426__auto__.cljs$core$IFn$_invoke$arity$3 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$3(_, f, executor) : m__4426__auto__.call(null, _, f, executor);
      } else {
        throw cljs.core.missing_protocol("IPromise.-thenErr", _);
      }
    }
  };

  G__22760 = function G__22760(_, f, executor) {
    switch (arguments.length) {
      case 2:
        return G__22760__2.call(this, _, f);

      case 3:
        return G__22760__3.call(this, _, f, executor);
    }

    throw new Error('Invalid arity: ' + arguments.length);
  };

  G__22760.cljs$core$IFn$_invoke$arity$2 = G__22760__2;
  G__22760.cljs$core$IFn$_invoke$arity$3 = G__22760__3;
  return G__22760;
}();
/**
 * Apply function to a failed computation. and flatten if promise found.
 */


promesa.protocols._thenErr = function promesa$protocols$_thenErr(var_args) {
  var G__22714 = arguments.length;

  switch (G__22714) {
    case 2:
      return promesa.protocols._thenErr.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return promesa.protocols._thenErr.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

promesa.protocols._thenErr.cljs$core$IFn$_invoke$arity$2 = function (_, f) {
  if (!(_ == null) && !(_.promesa$protocols$IPromise$_thenErr$arity$2 == null)) {
    return _.promesa$protocols$IPromise$_thenErr$arity$2(_, f);
  } else {
    return promesa$protocols$IPromise$_thenErr$dyn_22759(_, f);
  }
};

promesa.protocols._thenErr.cljs$core$IFn$_invoke$arity$3 = function (_, f, executor) {
  if (!(_ == null) && !(_.promesa$protocols$IPromise$_thenErr$arity$3 == null)) {
    return _.promesa$protocols$IPromise$_thenErr$arity$3(_, f, executor);
  } else {
    return promesa$protocols$IPromise$_thenErr$dyn_22759(_, f, executor);
  }
};

promesa.protocols._thenErr.cljs$lang$maxFixedArity = 3;

var promesa$protocols$IPromise$_handle$dyn_22762 = function () {
  var G__22763 = null;

  var G__22763__2 = function G__22763__2(_, f) {
    var x__4428__auto__ = _ == null ? null : _;

    var m__4429__auto__ = promesa.protocols._handle[goog.typeOf(x__4428__auto__)];

    if (!(m__4429__auto__ == null)) {
      return m__4429__auto__.cljs$core$IFn$_invoke$arity$2 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$2(_, f) : m__4429__auto__.call(null, _, f);
    } else {
      var m__4426__auto__ = promesa.protocols._handle["_"];

      if (!(m__4426__auto__ == null)) {
        return m__4426__auto__.cljs$core$IFn$_invoke$arity$2 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$2(_, f) : m__4426__auto__.call(null, _, f);
      } else {
        throw cljs.core.missing_protocol("IPromise.-handle", _);
      }
    }
  };

  var G__22763__3 = function G__22763__3(_, f, executor) {
    var x__4428__auto__ = _ == null ? null : _;

    var m__4429__auto__ = promesa.protocols._handle[goog.typeOf(x__4428__auto__)];

    if (!(m__4429__auto__ == null)) {
      return m__4429__auto__.cljs$core$IFn$_invoke$arity$3 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$3(_, f, executor) : m__4429__auto__.call(null, _, f, executor);
    } else {
      var m__4426__auto__ = promesa.protocols._handle["_"];

      if (!(m__4426__auto__ == null)) {
        return m__4426__auto__.cljs$core$IFn$_invoke$arity$3 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$3(_, f, executor) : m__4426__auto__.call(null, _, f, executor);
      } else {
        throw cljs.core.missing_protocol("IPromise.-handle", _);
      }
    }
  };

  G__22763 = function G__22763(_, f, executor) {
    switch (arguments.length) {
      case 2:
        return G__22763__2.call(this, _, f);

      case 3:
        return G__22763__3.call(this, _, f, executor);
    }

    throw new Error('Invalid arity: ' + arguments.length);
  };

  G__22763.cljs$core$IFn$_invoke$arity$2 = G__22763__2;
  G__22763.cljs$core$IFn$_invoke$arity$3 = G__22763__3;
  return G__22763;
}();
/**
 * Apply function to a computation identpendently if is failed or
 *  successful and flatten if promise found.
 */


promesa.protocols._handle = function promesa$protocols$_handle(var_args) {
  var G__22718 = arguments.length;

  switch (G__22718) {
    case 2:
      return promesa.protocols._handle.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return promesa.protocols._handle.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

promesa.protocols._handle.cljs$core$IFn$_invoke$arity$2 = function (_, f) {
  if (!(_ == null) && !(_.promesa$protocols$IPromise$_handle$arity$2 == null)) {
    return _.promesa$protocols$IPromise$_handle$arity$2(_, f);
  } else {
    return promesa$protocols$IPromise$_handle$dyn_22762(_, f);
  }
};

promesa.protocols._handle.cljs$core$IFn$_invoke$arity$3 = function (_, f, executor) {
  if (!(_ == null) && !(_.promesa$protocols$IPromise$_handle$arity$3 == null)) {
    return _.promesa$protocols$IPromise$_handle$arity$3(_, f, executor);
  } else {
    return promesa$protocols$IPromise$_handle$dyn_22762(_, f, executor);
  }
};

promesa.protocols._handle.cljs$lang$maxFixedArity = 3;

var promesa$protocols$IPromise$_finally$dyn_22767 = function () {
  var G__22768 = null;

  var G__22768__2 = function G__22768__2(_, f) {
    var x__4428__auto__ = _ == null ? null : _;

    var m__4429__auto__ = promesa.protocols._finally[goog.typeOf(x__4428__auto__)];

    if (!(m__4429__auto__ == null)) {
      return m__4429__auto__.cljs$core$IFn$_invoke$arity$2 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$2(_, f) : m__4429__auto__.call(null, _, f);
    } else {
      var m__4426__auto__ = promesa.protocols._finally["_"];

      if (!(m__4426__auto__ == null)) {
        return m__4426__auto__.cljs$core$IFn$_invoke$arity$2 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$2(_, f) : m__4426__auto__.call(null, _, f);
      } else {
        throw cljs.core.missing_protocol("IPromise.-finally", _);
      }
    }
  };

  var G__22768__3 = function G__22768__3(_, f, executor) {
    var x__4428__auto__ = _ == null ? null : _;

    var m__4429__auto__ = promesa.protocols._finally[goog.typeOf(x__4428__auto__)];

    if (!(m__4429__auto__ == null)) {
      return m__4429__auto__.cljs$core$IFn$_invoke$arity$3 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$3(_, f, executor) : m__4429__auto__.call(null, _, f, executor);
    } else {
      var m__4426__auto__ = promesa.protocols._finally["_"];

      if (!(m__4426__auto__ == null)) {
        return m__4426__auto__.cljs$core$IFn$_invoke$arity$3 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$3(_, f, executor) : m__4426__auto__.call(null, _, f, executor);
      } else {
        throw cljs.core.missing_protocol("IPromise.-finally", _);
      }
    }
  };

  G__22768 = function G__22768(_, f, executor) {
    switch (arguments.length) {
      case 2:
        return G__22768__2.call(this, _, f);

      case 3:
        return G__22768__3.call(this, _, f, executor);
    }

    throw new Error('Invalid arity: ' + arguments.length);
  };

  G__22768.cljs$core$IFn$_invoke$arity$2 = G__22768__2;
  G__22768.cljs$core$IFn$_invoke$arity$3 = G__22768__3;
  return G__22768;
}();
/**
 * Apply function to a computation identpendently if is failed or
 *  successful; the return value is ignored.
 */


promesa.protocols._finally = function promesa$protocols$_finally(var_args) {
  var G__22722 = arguments.length;

  switch (G__22722) {
    case 2:
      return promesa.protocols._finally.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return promesa.protocols._finally.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

promesa.protocols._finally.cljs$core$IFn$_invoke$arity$2 = function (_, f) {
  if (!(_ == null) && !(_.promesa$protocols$IPromise$_finally$arity$2 == null)) {
    return _.promesa$protocols$IPromise$_finally$arity$2(_, f);
  } else {
    return promesa$protocols$IPromise$_finally$dyn_22767(_, f);
  }
};

promesa.protocols._finally.cljs$core$IFn$_invoke$arity$3 = function (_, f, executor) {
  if (!(_ == null) && !(_.promesa$protocols$IPromise$_finally$arity$3 == null)) {
    return _.promesa$protocols$IPromise$_finally$arity$3(_, f, executor);
  } else {
    return promesa$protocols$IPromise$_finally$dyn_22767(_, f, executor);
  }
};

promesa.protocols._finally.cljs$lang$maxFixedArity = 3;
/**
 * Additional state/introspection abstraction.
 * @interface
 */

promesa.protocols.IState = function () {};

var promesa$protocols$IState$_extract$dyn_22771 = function promesa$protocols$IState$_extract$dyn_22771(_) {
  var x__4428__auto__ = _ == null ? null : _;

  var m__4429__auto__ = promesa.protocols._extract[goog.typeOf(x__4428__auto__)];

  if (!(m__4429__auto__ == null)) {
    return m__4429__auto__.cljs$core$IFn$_invoke$arity$1 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$1(_) : m__4429__auto__.call(null, _);
  } else {
    var m__4426__auto__ = promesa.protocols._extract["_"];

    if (!(m__4426__auto__ == null)) {
      return m__4426__auto__.cljs$core$IFn$_invoke$arity$1 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$1(_) : m__4426__auto__.call(null, _);
    } else {
      throw cljs.core.missing_protocol("IState.-extract", _);
    }
  }
};
/**
 * Extract the current value.
 */


promesa.protocols._extract = function promesa$protocols$_extract(_) {
  if (!(_ == null) && !(_.promesa$protocols$IState$_extract$arity$1 == null)) {
    return _.promesa$protocols$IState$_extract$arity$1(_);
  } else {
    return promesa$protocols$IState$_extract$dyn_22771(_);
  }
};

var promesa$protocols$IState$_resolved_QMARK_$dyn_22772 = function promesa$protocols$IState$_resolved_QMARK_$dyn_22772(_) {
  var x__4428__auto__ = _ == null ? null : _;

  var m__4429__auto__ = promesa.protocols._resolved_QMARK_[goog.typeOf(x__4428__auto__)];

  if (!(m__4429__auto__ == null)) {
    return m__4429__auto__.cljs$core$IFn$_invoke$arity$1 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$1(_) : m__4429__auto__.call(null, _);
  } else {
    var m__4426__auto__ = promesa.protocols._resolved_QMARK_["_"];

    if (!(m__4426__auto__ == null)) {
      return m__4426__auto__.cljs$core$IFn$_invoke$arity$1 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$1(_) : m__4426__auto__.call(null, _);
    } else {
      throw cljs.core.missing_protocol("IState.-resolved?", _);
    }
  }
};
/**
 * Returns true if a promise is resolved.
 */


promesa.protocols._resolved_QMARK_ = function promesa$protocols$_resolved_QMARK_(_) {
  if (!(_ == null) && !(_.promesa$protocols$IState$_resolved_QMARK_$arity$1 == null)) {
    return _.promesa$protocols$IState$_resolved_QMARK_$arity$1(_);
  } else {
    return promesa$protocols$IState$_resolved_QMARK_$dyn_22772(_);
  }
};

var promesa$protocols$IState$_rejected_QMARK_$dyn_22773 = function promesa$protocols$IState$_rejected_QMARK_$dyn_22773(_) {
  var x__4428__auto__ = _ == null ? null : _;

  var m__4429__auto__ = promesa.protocols._rejected_QMARK_[goog.typeOf(x__4428__auto__)];

  if (!(m__4429__auto__ == null)) {
    return m__4429__auto__.cljs$core$IFn$_invoke$arity$1 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$1(_) : m__4429__auto__.call(null, _);
  } else {
    var m__4426__auto__ = promesa.protocols._rejected_QMARK_["_"];

    if (!(m__4426__auto__ == null)) {
      return m__4426__auto__.cljs$core$IFn$_invoke$arity$1 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$1(_) : m__4426__auto__.call(null, _);
    } else {
      throw cljs.core.missing_protocol("IState.-rejected?", _);
    }
  }
};
/**
 * Returns true if a promise is rejected.
 */


promesa.protocols._rejected_QMARK_ = function promesa$protocols$_rejected_QMARK_(_) {
  if (!(_ == null) && !(_.promesa$protocols$IState$_rejected_QMARK_$arity$1 == null)) {
    return _.promesa$protocols$IState$_rejected_QMARK_$arity$1(_);
  } else {
    return promesa$protocols$IState$_rejected_QMARK_$dyn_22773(_);
  }
};

var promesa$protocols$IState$_pending_QMARK_$dyn_22774 = function promesa$protocols$IState$_pending_QMARK_$dyn_22774(_) {
  var x__4428__auto__ = _ == null ? null : _;

  var m__4429__auto__ = promesa.protocols._pending_QMARK_[goog.typeOf(x__4428__auto__)];

  if (!(m__4429__auto__ == null)) {
    return m__4429__auto__.cljs$core$IFn$_invoke$arity$1 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$1(_) : m__4429__auto__.call(null, _);
  } else {
    var m__4426__auto__ = promesa.protocols._pending_QMARK_["_"];

    if (!(m__4426__auto__ == null)) {
      return m__4426__auto__.cljs$core$IFn$_invoke$arity$1 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$1(_) : m__4426__auto__.call(null, _);
    } else {
      throw cljs.core.missing_protocol("IState.-pending?", _);
    }
  }
};
/**
 * Retutns true if a promise is pending.
 */


promesa.protocols._pending_QMARK_ = function promesa$protocols$_pending_QMARK_(_) {
  if (!(_ == null) && !(_.promesa$protocols$IState$_pending_QMARK_$arity$1 == null)) {
    return _.promesa$protocols$IState$_pending_QMARK_$arity$1(_);
  } else {
    return promesa$protocols$IState$_pending_QMARK_$dyn_22774(_);
  }
};
/**
 * A promise constructor abstraction.
 * @interface
 */


promesa.protocols.IPromiseFactory = function () {};

var promesa$protocols$IPromiseFactory$_promise$dyn_22775 = function promesa$protocols$IPromiseFactory$_promise$dyn_22775(_) {
  var x__4428__auto__ = _ == null ? null : _;

  var m__4429__auto__ = promesa.protocols._promise[goog.typeOf(x__4428__auto__)];

  if (!(m__4429__auto__ == null)) {
    return m__4429__auto__.cljs$core$IFn$_invoke$arity$1 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$1(_) : m__4429__auto__.call(null, _);
  } else {
    var m__4426__auto__ = promesa.protocols._promise["_"];

    if (!(m__4426__auto__ == null)) {
      return m__4426__auto__.cljs$core$IFn$_invoke$arity$1 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$1(_) : m__4426__auto__.call(null, _);
    } else {
      throw cljs.core.missing_protocol("IPromiseFactory.-promise", _);
    }
  }
};
/**
 * Create a promise instance from other types
 */


promesa.protocols._promise = function promesa$protocols$_promise(_) {
  if (!(_ == null) && !(_.promesa$protocols$IPromiseFactory$_promise$arity$1 == null)) {
    return _.promesa$protocols$IPromiseFactory$_promise$arity$1(_);
  } else {
    return promesa$protocols$IPromiseFactory$_promise$dyn_22775(_);
  }
};
/**
 * A cancellation abstraction.
 * @interface
 */


promesa.protocols.ICancellable = function () {};

var promesa$protocols$ICancellable$_cancel_BANG_$dyn_22776 = function promesa$protocols$ICancellable$_cancel_BANG_$dyn_22776(_) {
  var x__4428__auto__ = _ == null ? null : _;

  var m__4429__auto__ = promesa.protocols._cancel_BANG_[goog.typeOf(x__4428__auto__)];

  if (!(m__4429__auto__ == null)) {
    return m__4429__auto__.cljs$core$IFn$_invoke$arity$1 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$1(_) : m__4429__auto__.call(null, _);
  } else {
    var m__4426__auto__ = promesa.protocols._cancel_BANG_["_"];

    if (!(m__4426__auto__ == null)) {
      return m__4426__auto__.cljs$core$IFn$_invoke$arity$1 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$1(_) : m__4426__auto__.call(null, _);
    } else {
      throw cljs.core.missing_protocol("ICancellable.-cancel!", _);
    }
  }
};

promesa.protocols._cancel_BANG_ = function promesa$protocols$_cancel_BANG_(_) {
  if (!(_ == null) && !(_.promesa$protocols$ICancellable$_cancel_BANG_$arity$1 == null)) {
    return _.promesa$protocols$ICancellable$_cancel_BANG_$arity$1(_);
  } else {
    return promesa$protocols$ICancellable$_cancel_BANG_$dyn_22776(_);
  }
};

var promesa$protocols$ICancellable$_cancelled_QMARK_$dyn_22777 = function promesa$protocols$ICancellable$_cancelled_QMARK_$dyn_22777(_) {
  var x__4428__auto__ = _ == null ? null : _;

  var m__4429__auto__ = promesa.protocols._cancelled_QMARK_[goog.typeOf(x__4428__auto__)];

  if (!(m__4429__auto__ == null)) {
    return m__4429__auto__.cljs$core$IFn$_invoke$arity$1 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$1(_) : m__4429__auto__.call(null, _);
  } else {
    var m__4426__auto__ = promesa.protocols._cancelled_QMARK_["_"];

    if (!(m__4426__auto__ == null)) {
      return m__4426__auto__.cljs$core$IFn$_invoke$arity$1 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$1(_) : m__4426__auto__.call(null, _);
    } else {
      throw cljs.core.missing_protocol("ICancellable.-cancelled?", _);
    }
  }
};

promesa.protocols._cancelled_QMARK_ = function promesa$protocols$_cancelled_QMARK_(_) {
  if (!(_ == null) && !(_.promesa$protocols$ICancellable$_cancelled_QMARK_$arity$1 == null)) {
    return _.promesa$protocols$ICancellable$_cancelled_QMARK_$arity$1(_);
  } else {
    return promesa$protocols$ICancellable$_cancelled_QMARK_$dyn_22777(_);
  }
};
/**
 * @interface
 */


promesa.protocols.ICompletable = function () {};

var promesa$protocols$ICompletable$_resolve_BANG_$dyn_22778 = function promesa$protocols$ICompletable$_resolve_BANG_$dyn_22778(_, v) {
  var x__4428__auto__ = _ == null ? null : _;

  var m__4429__auto__ = promesa.protocols._resolve_BANG_[goog.typeOf(x__4428__auto__)];

  if (!(m__4429__auto__ == null)) {
    return m__4429__auto__.cljs$core$IFn$_invoke$arity$2 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$2(_, v) : m__4429__auto__.call(null, _, v);
  } else {
    var m__4426__auto__ = promesa.protocols._resolve_BANG_["_"];

    if (!(m__4426__auto__ == null)) {
      return m__4426__auto__.cljs$core$IFn$_invoke$arity$2 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$2(_, v) : m__4426__auto__.call(null, _, v);
    } else {
      throw cljs.core.missing_protocol("ICompletable.-resolve!", _);
    }
  }
};
/**
 * Deliver a value to empty promise.
 */


promesa.protocols._resolve_BANG_ = function promesa$protocols$_resolve_BANG_(_, v) {
  if (!(_ == null) && !(_.promesa$protocols$ICompletable$_resolve_BANG_$arity$2 == null)) {
    return _.promesa$protocols$ICompletable$_resolve_BANG_$arity$2(_, v);
  } else {
    return promesa$protocols$ICompletable$_resolve_BANG_$dyn_22778(_, v);
  }
};

var promesa$protocols$ICompletable$_reject_BANG_$dyn_22779 = function promesa$protocols$ICompletable$_reject_BANG_$dyn_22779(_, e) {
  var x__4428__auto__ = _ == null ? null : _;

  var m__4429__auto__ = promesa.protocols._reject_BANG_[goog.typeOf(x__4428__auto__)];

  if (!(m__4429__auto__ == null)) {
    return m__4429__auto__.cljs$core$IFn$_invoke$arity$2 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$2(_, e) : m__4429__auto__.call(null, _, e);
  } else {
    var m__4426__auto__ = promesa.protocols._reject_BANG_["_"];

    if (!(m__4426__auto__ == null)) {
      return m__4426__auto__.cljs$core$IFn$_invoke$arity$2 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$2(_, e) : m__4426__auto__.call(null, _, e);
    } else {
      throw cljs.core.missing_protocol("ICompletable.-reject!", _);
    }
  }
};
/**
 * Deliver an error to empty promise.
 */


promesa.protocols._reject_BANG_ = function promesa$protocols$_reject_BANG_(_, e) {
  if (!(_ == null) && !(_.promesa$protocols$ICompletable$_reject_BANG_$arity$2 == null)) {
    return _.promesa$protocols$ICompletable$_reject_BANG_$arity$2(_, e);
  } else {
    return promesa$protocols$ICompletable$_reject_BANG_$dyn_22779(_, e);
  }
};
/**
 * @interface
 */


promesa.protocols.IExecutor = function () {};

var promesa$protocols$IExecutor$_run_BANG_$dyn_22784 = function promesa$protocols$IExecutor$_run_BANG_$dyn_22784(_, task) {
  var x__4428__auto__ = _ == null ? null : _;

  var m__4429__auto__ = promesa.protocols._run_BANG_[goog.typeOf(x__4428__auto__)];

  if (!(m__4429__auto__ == null)) {
    return m__4429__auto__.cljs$core$IFn$_invoke$arity$2 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$2(_, task) : m__4429__auto__.call(null, _, task);
  } else {
    var m__4426__auto__ = promesa.protocols._run_BANG_["_"];

    if (!(m__4426__auto__ == null)) {
      return m__4426__auto__.cljs$core$IFn$_invoke$arity$2 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$2(_, task) : m__4426__auto__.call(null, _, task);
    } else {
      throw cljs.core.missing_protocol("IExecutor.-run!", _);
    }
  }
};
/**
 * Run a task and return a promise.
 */


promesa.protocols._run_BANG_ = function promesa$protocols$_run_BANG_(_, task) {
  if (!(_ == null) && !(_.promesa$protocols$IExecutor$_run_BANG_$arity$2 == null)) {
    return _.promesa$protocols$IExecutor$_run_BANG_$arity$2(_, task);
  } else {
    return promesa$protocols$IExecutor$_run_BANG_$dyn_22784(_, task);
  }
};

var promesa$protocols$IExecutor$_submit_BANG_$dyn_22785 = function promesa$protocols$IExecutor$_submit_BANG_$dyn_22785(_, task) {
  var x__4428__auto__ = _ == null ? null : _;

  var m__4429__auto__ = promesa.protocols._submit_BANG_[goog.typeOf(x__4428__auto__)];

  if (!(m__4429__auto__ == null)) {
    return m__4429__auto__.cljs$core$IFn$_invoke$arity$2 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$2(_, task) : m__4429__auto__.call(null, _, task);
  } else {
    var m__4426__auto__ = promesa.protocols._submit_BANG_["_"];

    if (!(m__4426__auto__ == null)) {
      return m__4426__auto__.cljs$core$IFn$_invoke$arity$2 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$2(_, task) : m__4426__auto__.call(null, _, task);
    } else {
      throw cljs.core.missing_protocol("IExecutor.-submit!", _);
    }
  }
};
/**
 * Submit a task and return a promise.
 */


promesa.protocols._submit_BANG_ = function promesa$protocols$_submit_BANG_(_, task) {
  if (!(_ == null) && !(_.promesa$protocols$IExecutor$_submit_BANG_$arity$2 == null)) {
    return _.promesa$protocols$IExecutor$_submit_BANG_$arity$2(_, task);
  } else {
    return promesa$protocols$IExecutor$_submit_BANG_$dyn_22785(_, task);
  }
};
/**
 * A generic abstraction for scheduler facilities.
 * @interface
 */


promesa.protocols.IScheduler = function () {};

var promesa$protocols$IScheduler$_schedule_BANG_$dyn_22786 = function promesa$protocols$IScheduler$_schedule_BANG_$dyn_22786(_, ms, func) {
  var x__4428__auto__ = _ == null ? null : _;

  var m__4429__auto__ = promesa.protocols._schedule_BANG_[goog.typeOf(x__4428__auto__)];

  if (!(m__4429__auto__ == null)) {
    return m__4429__auto__.cljs$core$IFn$_invoke$arity$3 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$3(_, ms, func) : m__4429__auto__.call(null, _, ms, func);
  } else {
    var m__4426__auto__ = promesa.protocols._schedule_BANG_["_"];

    if (!(m__4426__auto__ == null)) {
      return m__4426__auto__.cljs$core$IFn$_invoke$arity$3 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$3(_, ms, func) : m__4426__auto__.call(null, _, ms, func);
    } else {
      throw cljs.core.missing_protocol("IScheduler.-schedule!", _);
    }
  }
};
/**
 * Schedule a function to be executed in future.
 */


promesa.protocols._schedule_BANG_ = function promesa$protocols$_schedule_BANG_(_, ms, func) {
  if (!(_ == null) && !(_.promesa$protocols$IScheduler$_schedule_BANG_$arity$3 == null)) {
    return _.promesa$protocols$IScheduler$_schedule_BANG_$arity$3(_, ms, func);
  } else {
    return promesa$protocols$IScheduler$_schedule_BANG_$dyn_22786(_, ms, func);
  }
};

Object.defineProperty(module.exports, "_reject_BANG_", {
  enumerable: false,
  get: function get() {
    return promesa.protocols._reject_BANG_;
  }
});
Object.defineProperty(module.exports, "_map", {
  enumerable: false,
  get: function get() {
    return promesa.protocols._map;
  }
});
Object.defineProperty(module.exports, "_resolve_BANG_", {
  enumerable: false,
  get: function get() {
    return promesa.protocols._resolve_BANG_;
  }
});
Object.defineProperty(module.exports, "IPromiseFactory", {
  enumerable: false,
  get: function get() {
    return promesa.protocols.IPromiseFactory;
  }
});
Object.defineProperty(module.exports, "_schedule_BANG_", {
  enumerable: false,
  get: function get() {
    return promesa.protocols._schedule_BANG_;
  }
});
Object.defineProperty(module.exports, "_run_BANG_", {
  enumerable: false,
  get: function get() {
    return promesa.protocols._run_BANG_;
  }
});
Object.defineProperty(module.exports, "_promise", {
  enumerable: false,
  get: function get() {
    return promesa.protocols._promise;
  }
});
Object.defineProperty(module.exports, "_then", {
  enumerable: false,
  get: function get() {
    return promesa.protocols._then;
  }
});
Object.defineProperty(module.exports, "_extract", {
  enumerable: false,
  get: function get() {
    return promesa.protocols._extract;
  }
});
Object.defineProperty(module.exports, "IExecutor", {
  enumerable: false,
  get: function get() {
    return promesa.protocols.IExecutor;
  }
});
Object.defineProperty(module.exports, "IScheduler", {
  enumerable: false,
  get: function get() {
    return promesa.protocols.IScheduler;
  }
});
Object.defineProperty(module.exports, "IState", {
  enumerable: false,
  get: function get() {
    return promesa.protocols.IState;
  }
});
Object.defineProperty(module.exports, "_submit_BANG_", {
  enumerable: false,
  get: function get() {
    return promesa.protocols._submit_BANG_;
  }
});
Object.defineProperty(module.exports, "_cancelled_QMARK_", {
  enumerable: false,
  get: function get() {
    return promesa.protocols._cancelled_QMARK_;
  }
});
Object.defineProperty(module.exports, "_thenErr", {
  enumerable: false,
  get: function get() {
    return promesa.protocols._thenErr;
  }
});
Object.defineProperty(module.exports, "_resolved_QMARK_", {
  enumerable: false,
  get: function get() {
    return promesa.protocols._resolved_QMARK_;
  }
});
Object.defineProperty(module.exports, "_handle", {
  enumerable: false,
  get: function get() {
    return promesa.protocols._handle;
  }
});
Object.defineProperty(module.exports, "_pending_QMARK_", {
  enumerable: false,
  get: function get() {
    return promesa.protocols._pending_QMARK_;
  }
});
Object.defineProperty(module.exports, "_finally", {
  enumerable: false,
  get: function get() {
    return promesa.protocols._finally;
  }
});
Object.defineProperty(module.exports, "_cancel_BANG_", {
  enumerable: false,
  get: function get() {
    return promesa.protocols._cancel_BANG_;
  }
});
Object.defineProperty(module.exports, "_rejected_QMARK_", {
  enumerable: false,
  get: function get() {
    return promesa.protocols._rejected_QMARK_;
  }
});
Object.defineProperty(module.exports, "_mapErr", {
  enumerable: false,
  get: function get() {
    return promesa.protocols._mapErr;
  }
});
Object.defineProperty(module.exports, "ICancellable", {
  enumerable: false,
  get: function get() {
    return promesa.protocols.ICancellable;
  }
});
Object.defineProperty(module.exports, "IPromise", {
  enumerable: false,
  get: function get() {
    return promesa.protocols.IPromise;
  }
});
Object.defineProperty(module.exports, "_bind", {
  enumerable: false,
  get: function get() {
    return promesa.protocols._bind;
  }
});
Object.defineProperty(module.exports, "ICompletable", {
  enumerable: false,
  get: function get() {
    return promesa.protocols.ICompletable;
  }
});